import { addWeeks, subWeeks } from 'date-fns'
import { useEffect, useRef } from 'react'
import { registerHotKey, unregisterHotKey } from '@opallabs/kuiper'
import { calendarSelectors, quasiTabsSelectors } from '@opallabs/lapidary'

const unregisterHotKeys = () => {
  unregisterHotKey('left')
  unregisterHotKey('right')
}

// @note This is a hack to ignore keyboard navigation when within components
// that also listen for keypresses.
const ignoredKeypressClassNames = [
  'lapidary-tabs',
  quasiTabsSelectors.root,
  calendarSelectors.date,
]
function navigateFromKeypress({ direction, event, focusedDay, onWeekChange }) {
  const ignoredSelector = event.composedPath().find((node) => {
    if (!node.classList) return false

    const classNames = Array.from(node.classList)
    return (
      window._.intersection(classNames, ignoredKeypressClassNames).length > 0
    )
  })
  if (ignoredSelector) return

  const parsed = focusedDay
  const method = direction === 'left' ? subWeeks : addWeeks
  onWeekChange(method(parsed, 1))
}

const registerHotKeys = ({ focusedDay, onWeekChange }) => {
  registerHotKey('left', (event) =>
    navigateFromKeypress({ direction: 'left', event, focusedDay, onWeekChange })
  )
  registerHotKey('right', (event) =>
    navigateFromKeypress({
      direction: 'right',
      event,
      focusedDay,
      onWeekChange,
    })
  )
}

/**
 * Left and right step a week at a time, except while a shroud or a modal is
 * over the week — anything on top of it listens for its own keypresses.
 */
export const useWeekHotKeys = ({
  focusedDay,
  isShroudVisible,
  onWeekChange,
}) => {
  const didMountRef = useRef(false)

  useEffect(() => {
    if (!didMountRef.current) {
      registerHotKeys({ focusedDay, onWeekChange })
      didMountRef.current = true
    }
    if (didMountRef.current && !isShroudVisible) {
      registerHotKeys({ focusedDay, onWeekChange })
    }
    if (isShroudVisible) {
      unregisterHotKeys()
    }
    return () => {
      unregisterHotKeys()
    }
  }, [focusedDay, isShroudVisible]) // eslint-disable-line react-hooks/exhaustive-deps
}
